import isCountryWithBanner from 'components/betting-warning-banner/utils/is-country-with-banner';
import Icon from 'components/Icon/Icon.component';
import { useSlideInMenuControlls } from 'components/SlideInMenu/SlideInMenu.hooks';
import HambugerSvgIconComponent from 'images/icons/hamburger-menu.svg?react';
import React, { MouseEvent, MouseEventHandler, useCallback } from 'react';
import { NavbarContent } from 'services/cmsContent/cmsContent.types';
import { SessionTimerIframe } from '../ExpandedNavbar/partials/session-timer-iframe';
import { CompactHomepageLink } from './components/compact-homepage-link';
import {
  FlexWrapper,
  HamburgerButton,
  NavabarInnerContainer,
  Notifications,
  WithBannerFlexWrapper,
} from './style/CompactNavbar.style';

type CompactNavbarProps = {
  onMenuClick?: MouseEventHandler;
  navbarContent: NavbarContent;
  children?: React.ReactNode;
  isOverlayActive?: boolean;
};

function CompactNavbar({
  onMenuClick,
  children,
  navbarContent,
  isOverlayActive,
}: CompactNavbarProps) {
  const { openSlideInMenu } = useSlideInMenuControlls();

  const FlexWrapperComponent = isCountryWithBanner()
    ? WithBannerFlexWrapper
    : FlexWrapper;

  const handleClick = useCallback(
    (evt: MouseEvent<HTMLButtonElement>) => {
      if (typeof onMenuClick === 'function') {
        onMenuClick(evt);
      }

      if (evt.defaultPrevented) {
        return;
      }

      openSlideInMenu();
    },
    [onMenuClick, openSlideInMenu],
  );

  return (
    <FlexWrapperComponent $isOverlayActive={isOverlayActive}>
      <SessionTimerIframe />
      <NavabarInnerContainer>
        <HamburgerButton
          aria-label="open menu"
          title="menu"
          onClick={handleClick}
        >
          <Icon svgIconComponent={HambugerSvgIconComponent} display="block" />
        </HamburgerButton>
        <CompactHomepageLink logoLink={navbarContent.logoLink} />
        {children && <Notifications>{children}</Notifications>}
      </NavabarInnerContainer>
    </FlexWrapperComponent>
  );
}

export default CompactNavbar;
